var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoTypeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/1999/xlink",
    width: 28.94,
    height: 28.94,
    viewBox: "0 0 28.94 28.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "video-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27409",
    "data-name": "Rectangle 27409",
    width: 28.94,
    height: 28.94,
    transform: "translate(131 1542)",
    fill: "#7e59d1",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_393",
    "data-name": "Mask Group 393",
    transform: "translate(-131 -1542)",
    clipPath: "url(#video-icon)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_76_",
    "data-name": "svgexport-6 (76)",
    transform: "translate(131 1542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Live_1_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10622",
    "data-name": "Path 10622",
    d: "M26.4,7.09H2.544A2.546,2.546,0,0,0,0,9.633V19.808a2.546,2.546,0,0,0,2.544,2.544H26.4a2.546,2.546,0,0,0,2.544-2.544V9.633A2.546,2.546,0,0,0,26.4,7.09ZM7.687,18.96H4.3a.847.847,0,0,1-.848-.848V11.329a.848.848,0,1,1,1.7,0v5.935H7.687a.848.848,0,0,1,0,1.7Zm4.239-.848a.848.848,0,1,1-1.7,0V11.329a.848.848,0,1,1,1.7,0Zm6.757-6.577-1.7,6.783a.847.847,0,0,1-1.644,0l-1.7-6.783a.847.847,0,0,1,1.644-.411l.874,3.492.874-3.492a.847.847,0,0,1,1.644.411Zm5.961,2.338a.848.848,0,1,1,0,1.7H22.1v1.7h2.544a.848.848,0,0,1,0,1.7H21.253a.847.847,0,0,1-.848-.848V11.329a.847.847,0,0,1,.848-.848h3.391a.848.848,0,0,1,0,1.7H22.1v1.7Z",
    transform: "translate(0 6.589)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10422",
    "data-name": "Group 10422",
    transform: "translate(5.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10623",
    "data-name": "Path 10623",
    d: "M4.526,11.531a9.367,9.367,0,0,1,0-11.193A.848.848,0,0,1,5.882,1.357a7.661,7.661,0,0,0,0,9.156.848.848,0,1,1-1.356,1.018Z",
    transform: "translate(-2.671 0)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10423",
    "data-name": "Group 10423",
    transform: "translate(20.406 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10624",
    "data-name": "Path 10624",
    d: "M10.915,11.7a.849.849,0,0,1-.169-1.187,7.661,7.661,0,0,0,0-9.156A.848.848,0,1,1,12.1.338a9.367,9.367,0,0,1,0,11.193.848.848,0,0,1-1.187.169Z",
    transform: "translate(-10.577 0)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10424",
    "data-name": "Group 10424",
    transform: "translate(8.531 1.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10625",
    "data-name": "Path 10625",
    d: "M5.937,9.075a5.924,5.924,0,0,1,0-7.914A.848.848,0,1,1,7.2,2.292a4.232,4.232,0,0,0,0,5.652A.848.848,0,1,1,5.937,9.075Z",
    transform: "translate(-4.422 -0.879)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10425",
    "data-name": "Group 10425",
    transform: "translate(17.414 1.696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10626",
    "data-name": "Path 10626",
    d: "M9.308,9.141a.848.848,0,0,1-.066-1.2,4.232,4.232,0,0,0,0-5.652.848.848,0,0,1,1.264-1.131,5.924,5.924,0,0,1,0,7.914.848.848,0,0,1-1.2.066Z",
    transform: "translate(-9.026 -0.879)",
    fill: "#7e59d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10426",
    "data-name": "Group 10426",
    transform: "translate(11.926 3.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10627",
    "data-name": "Path 10627",
    d: "M8.725,6.845A2.544,2.544,0,1,1,11.269,4.3,2.546,2.546,0,0,1,8.725,6.845Z",
    transform: "translate(-6.182 -1.758)",
    fill: "#7e59d1"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoTypeIcon);
export default __webpack_public_path__ + "static/media/video-type-icon.2f4b850dc00de40a48e7b71ac90a4fb7.svg";
export { ForwardRef as ReactComponent };